export default "__VITE_ASSET__CBRKm1vx__"